import React from 'react';

import {
  ALERT_SEVERITIES,
  ALERT_SEVERITY_LABELS,
  STANDARD_ALERT_SEVERITY_TO_ALERT_MANAGER_SEVERITY
} from '@kentik/ui-shared/alerting/constants';
import AlertSeverityBars from 'app/views/alerting/components/AlertSeverityBars';

export interface SeverityOption {
  value: string;
  label: string;
  severity: string;
  iconElement: React.ReactNode;
}

const buildOptions = (toValue: (severity: string) => string): SeverityOption[] =>
  ALERT_SEVERITIES.map((severity: string) => ({
    value: toValue(severity),
    label: ALERT_SEVERITY_LABELS[severity],
    severity,
    iconElement: <AlertSeverityBars severity={severity} wrapperProps={{ mr: '4px' }} />
  }));

// Keyed on the standard alert severity; the AM variant is keyed on the stored SEVERITY_* name.
export const SEVERITY_OPTIONS = buildOptions((severity) => severity);

export const ALERT_MANAGER_SEVERITY_OPTIONS = buildOptions(
  (severity) => STANDARD_ALERT_SEVERITY_TO_ALERT_MANAGER_SEVERITY[severity]
);

export const severityOptionFormatter = ({ severity, label }: Partial<SeverityOption>) =>
  severity ? <AlertSeverityBars severity={severity} showLabel small /> : label;

export const severityValueRenderer = (option?: Partial<SeverityOption>) =>
  option?.severity ? <AlertSeverityBars severity={option.severity} showLabel small /> : (option?.label ?? '');
